<ng-container *transloco="let t">
  @let shippingCostResponseValue = shippingCostResponse();

  @if (calculatingShippingCost()) {
    <!-- Shipping calculation in progress -->
    <pxw-alert type="neutral" size="sm" display="inline">
      <pxw-icon icon="loading" [spin]="true" />
      {{ t('shippingCostResponse.calculating') }}
    </pxw-alert>
    <pxw-form-validation
      name="shippingCostCalculation"
      style="margin-top: 0.3em"
      [displayErrors]="isFormSubmitted()"
      [ngModel]="false"
      [requiredTrue]="true"
      [messages]="{ required: t('shippingCostResponse.calculatingError') }"
    />
  } @else if (shippingCostResponseValue) {
    @let selectedShippingOption = shippingCostResponseValue.shippingOption;

    @if (selectedShippingOption.type === typesOfShippings.DELIVERY) {
      @if (shippingCostResponseValue.deliveryCost && shippingCostResponseValue.deliveryCost > 0) {
        <!-- Display delivery cost -->
        <pxw-alert type="warning" size="sm" display="inline-block">
          <pxw-icon icon="shipping" #customIcon />
          {{ t('shippingCostResponse.costLabel') }}:
          <strong>{{ shippingCostResponseValue.deliveryCost | currencyFormat }}</strong>

          @if (selectedShippingOption.deliveryType === deliveryTypes.FIXED) {
            <ng-template #alertDetails>
              <span class="shipping-cost-helper">
                *{{ t('shippingCostResponse.costHelper') }}
              </span>
            </ng-template>
          }
        </pxw-alert>

        @if (shippingCostResponseValue.minimumPurchaseForFreeShipping) {
          <!-- Can unlock free shipping -->
          <pxw-alert
            type="info"
            appareance="bare"
            size="xs"
            display="inline-block"
            style="margin-top: 0.3em"
          >
            <pxw-icon icon="price-discount" #customIcon />
            *
            {{
              t('shippingCostResponse.minimumPurchaseForFreeShipping', {
                minimumPurchaseForFreeShipping:
                  shippingCostResponseValue.minimumPurchaseForFreeShipping | currencyFormat,
              })
            }}
          </pxw-alert>
        }
      } @else if (shippingCostResponseValue.deliveryCostToBeDefined) {
        <!-- Delivery cost to be defined -->
        <ng-container
          *ngTemplateOutlet="
            canContinueWithConfirmation;
            context: { message: t('shippingCostResponse.toBeDefined') }
          "
        />
      } @else if (shippingCostResponseValue.freeShippingGrantedAmount) {
        <!-- Free delivery granted -->
        <pxw-alert type="success" size="sm" display="inline-block">
          <pxw-icon icon="price-discount" #customIcon />
          {{ t('shippingCostResponse.freeShippingGranted') }}
        </pxw-alert>
      } @else if (shippingCostResponseValue.minimumPurchaseErrorAmount) {
        <!-- Minimum purchase error -->
        <ng-container
          *ngTemplateOutlet="
            shippingNotAllowed;
            context: {
              message: t('shippingCostResponse.minimumPurchaseError', {
                minimumPurchase:
                  shippingCostResponseValue.minimumPurchaseErrorAmount | currencyFormat,
              }),
            }
          "
        />
      } @else if (shippingCostResponseValue.shippingEstimate?.error) {
        <!-- Shipping estimate error -->
        <ng-container
          *ngTemplateOutlet="
            canContinueWithConfirmation;
            context: { message: shippingCostResponseValue.shippingEstimate?.error }
          "
        />
      } @else if (shippingCostResponseValue.outOfDeliveryZone) {
        <!-- Out of delivery zone -->
        @if (selectedShippingOption.outOfDeliveryZoneShippingAllowed) {
          <!-- Allowed with confirmation -->
          <ng-container
            *ngTemplateOutlet="
              canContinueWithConfirmation;
              context: {
                message: t('shippingCostResponse.outOfDeliveryZoneAlert'),
              }
            "
          />
        } @else {
          <!-- Shipping disabled -->
          <ng-container
            *ngTemplateOutlet="
              shippingNotAllowed;
              context: {
                message: t('shippingCostResponse.outOfDeliveryZoneForbiddenAlert'),
              }
            "
          />
        }
      }
    } @else if (selectedShippingOption.type === typesOfShippings.PARCEL) {
      @if (shippingCostResponseValue.deliveryCost && shippingCostResponseValue.deliveryCost > 0) {
        <!-- Display delivery cost -->
        <pxw-alert type="warning" size="sm" display="inline-block">
          <pxw-icon icon="shipping" #customIcon />
          {{ t('shippingCostResponse.costLabel') }}:
          <strong>{{ shippingCostResponseValue.deliveryCost | currencyFormat }} *</strong>

          <ng-template #alertDetails>
            <span class="shipping-cost-helper"> * Este pedido se envía por paquetería</span>
          </ng-template>
        </pxw-alert>
      }
    }
  }

  <ng-template #canContinueWithConfirmation let-message="message">
    <pxw-alert type="warning" size="sm" display="inline-block">
      {{ message }}

      <ng-template #alertDetails>
        <pxw-input-checkbox
          name="outOfDeliveryZoneConfirmation"
          [legend]="t('shippingCostResponse.outOfDeliveryZoneConfirmLabel')"
          [(ngModel)]="outOfDeliveryZoneConfirmed"
        />
      </ng-template>
    </pxw-alert>
    <pxw-form-validation
      name="outOfDeliveryZoneConfirmationValidation"
      style="margin-top: 0.3em"
      [displayErrors]="isFormSubmitted()"
      [ngModel]="outOfDeliveryZoneConfirmed()"
      [requiredTrue]="true"
    />
  </ng-template>
  <ng-template #shippingNotAllowed let-message="message">
    <pxw-form-validation
      name="outOfDeliveryZoneShippingNotAllowed"
      [displayErrors]="true"
      [ngModel]="false"
      [requiredTrue]="true"
      [messages]="{
        required: message,
      }"
    />
  </ng-template>
</ng-container>
